<template>
  <div>
      <van-nav-bar
        :title="title"
        :left-arrow="leftArrow"
        @click-left="goback()"
        :right-text="rightText"
        @click-right="go(goUrl)"
      ></van-nav-bar>
  </div>
</template>

<script>
export default {
  props: ["title", "leftArrow", "change", "rightText", "goUrl"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    goback() {
      if (
        this.goUrl &&
        this.goUrl !== "feed-output" &&
        this.goUrl !== "exchangeRecord"
      ) {
        this.$router.push({ name: "situation" });
      } else {
        this.$router.go(-1);
      }
    },
    go(res) {
      this.$router.push({ name: res });
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  font-size: 14px;
  [class*="van-hairline"]::after {
    border: 0;
  }
  .van-nav-bar {
    width: 100%;
    background:#FFA923;
    background-position: center;
  }
  .van-nav-bar__title {
    color: #fff;
  }
  .van-nav-bar__text {
    color: #fff;
  }
  .van-nav-bar .van-icon {
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar.vue